<template>
  <div class="input-typed-phone">
    <div>
      <slot name='before' />
      <div class="input-typed-phone__row" v-bind:style="`max-width: ${maxWidthPhone}px`">
        <input-phone
          class="input-typed-phone__field"
          v-bind:title="title"
          v-bind:value="value"
          v-bind:violations="violations"
          v-on:invalid="onInvalid"
          v-on:incomplete-input="onInput(type, $event)"
        />
        <div class="input-typed-phone__slot">
          <slot />
        </div>
      </div>
    </div>
    <textarea-length-limitation
      v-if="isNoteShow"
      v-bind:placeholder="`Примечание`"
      v-bind:max-length="noteMaxLength"
      v-bind:value="noteValue"
      v-bind:rows="noteRows"
      v-on:input="$emit('input-note', $event)"
    />
    <input-checkbox
      title="Городской"
      v-bind:value="isCity"
      v-on:input="onInputType"
    />
  </div>
</template>

<script>
import InputCheckbox from '@/components/InputCheckbox.vue';
import InputPhone from '@/components/InputPhone.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';

/**
 * @description Городской.
 * @type {string}
 */
const PHONE_TYPE_CITY = 'city';

/**
 * @description Сотовый.
 * @type {string}
 */
export const PHONE_TYPE_MOBILE = 'mobile';

/**
 * @description Компонент с выбором типа и вводом номера телефона.
 * @type {Vue}
 */
export default {
  components: { InputCheckbox, InputPhone, TextareaLengthLimitation },
  emits: ['input', 'invalid', 'input-note'],
  computed: {
    isCity() {
      return this.type === PHONE_TYPE_CITY;
    },
  },
  methods: {
    /**
     * @description Обработать ввод.
     * @param {string} type
     * @param {string} value
     * @returns {void}
     */
    onInput(type, value) {
      this.$emit('input', { type, value });
    },
    /**
     * @description Обработать некорректность поля.
     * @returns {void}
     */
    onInvalid() {
      this.$emit('invalid');
    },
    /**
     * @description Обработать ввод типа номера.
     * @param {boolean} value
     * @returns {void}
     */
    onInputType(value) {
      const newType = value ? PHONE_TYPE_CITY : PHONE_TYPE_MOBILE;
      this.onInput(newType, this.value);
    },
  },
  name: 'InputTypedPhone',
  props: {
    /**
     * @description Заголовок.
     */
    title: { default: 'Телефон', type: String },
    /**
     * @description Тип номера.
     */
    type: {
      required: true,
      type: String,
      validator: (input) => [PHONE_TYPE_CITY, PHONE_TYPE_MOBILE].indexOf(input) !== -1,
    },
    /**
     * @description Значение.
     */
    value: { required: true, type: String },
    /**
     * @description Список нарушений.
     */
    violations: { required: true, type: Array },
    /**
     * @description Максимальаная ширина контейнера с телефонным полем.
     */
    maxWidthPhone: { default: '', type: String },
    /**
     * @description Флаг. Показывать поле ввода "Примечание"?
     */
    isNoteShow: { default: () => false, type: Boolean },
    /**
     * @description Максимальная длинна "Примечания"
     */
    noteMaxLength: { default: 200, type: Number },
    /**
     * @description Текст примечания
     */
    noteValue: { default: '', type: String },
    /**
     * @description Кол-во строк у примечания
     */
    noteRows: { default: 2, type: Number },
  },
};
</script>
<style lang="scss" scoped>
.input-typed-phone {
  display: flex;
  flex-direction: column;
  gap: 8px;
  &__row {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }
  &__slot {
    display: flex;
    align-items: center;
    align-self: flex-end;
    gap: 10px;
    &:empty {
      display: none;
    }
  }
  ::v-deep .input-phone:has(p[role="alert"]) + &__slot {
    align-self: center;
  }
}

@media screen and (max-width: 480px) {
  .input-typed-phone {
    &__field {
      flex: 1;
    }
  }
}
</style>
